<template>
  <div class="page container">
    <Menu></Menu>
    <h1 class="title is-4  ">
      <small class="has-text-weight-bold">Pendentes</small>
    </h1>
    <div class="subtitle is-6">
      Inscritos no curso mas ques estão com o pagamento pendente.
    </div>
    <el-table
    :data="inscritos"
    stripe
    style="width: 100%">
    <el-table-column
      prop="nome"
      label="Nome"
      width="300">
    </el-table-column>
    <el-table-column
      prop="email"
      label="E-mail">
    </el-table-column>
    <el-table-column
      prop="cpf"
      label="Cpf">
    </el-table-column>
    
    <el-table-column
      prop="endereco"
      label="Endereço">
    </el-table-column>
    
    <el-table-column
      prop="estado"
      label="Estado">
    </el-table-column>
    <el-table-column
      prop="categoria"
      label="Categoria"
      width="180">
    </el-table-column>
    <el-table-column
      prop="address"
      label=""
      width="60">
      <template slot-scope="scope">
        
        <el-button-group>
          <el-button v-if='!scope.row.details.pago_em' type="default" size="small" @click="(e)=>setPago(scope.row)">
            <i class="fas fa-thumbs-down" ></i>
          </el-button>
           <el-button v-if='scope.row.details.pago_em' type="success" size="small" @click="(e)=>unsetPago(scope.row)">
            <i class="fas fa-thumbs-up" ></i>
          </el-button>
        </el-button-group>
      </template>
    </el-table-column>
  </el-table>
    <hr />
  </div>  
</template>

<script>
  import Menu from './_menu';
  import uuid from 'uuid/v4';
  import {Money} from 'v-money';
  import { VueEditor } from 'vue2-editor'
  import * as R from 'ramda';
  import axios from 'axios';

  export default {
    components: {
      Menu,
      Money,
      VueEditor
    },
    data() {
      return {
        inscritos: []
      }
    },
    methods: {
      setPago(e){
        console.log(e);
        axios({
            method: 'post',
            url: `${global.base}/api/admin/curso-user/${e.details.id}/pago`,
            headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
            }).then((r)=>{
              e.details.pago_em = r.data.pago_em;
          }).catch(()=>{
        })

      },
      unsetPago(e){
        axios({
            method: 'post',
            url: `${global.base}/api/admin/curso-user/${e.details.id}/unpago`,
            headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
            }).then((r)=>{
              e.details.pago_em = null;
          }).catch(()=>{
        })

      },
      addPlan() {
        const num = this.plans.length;
        this.plans.push(
          { id: num, 
            uuid: uuid(), 
            title: 'Sem título',
            description: '',
            price: 0.00,
            recorrente: true,
            garantia: 0,
            _viewOption: null
          }
        )
      },
      removePlan(c) {
        const idx = R.findIndex(R.propEq('uuid', c.uuid))(this.plans);
        if(idx >= 0)
          this.plans.splice(idx, 1);
      },
      onSubmit() {
        console.log('submit!');
      },
      toggleDetails(c) {
        if(c._viewOption){
          c._viewOption = '';
        }else{
          c._viewOption = 'details';
        }
      },
      getCurso(){
        const curso_id = this.$route.params.curso;
        global.Loading.begin(`Carregando o curso #${curso_id}`);
        axios.get(`${global.base}/api/admin/curso/${curso_id}/pendentes`,{
          headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
          }).then((r)=>{
            global.Loading.end();
            this.inscritos = r.data;
          }).catch(()=>{
            global.Loading.end();
          })
      }
    },
    mounted(){
      this.getCurso()
    }
  };
</script>

<style scope>
</style>